import { useEffect, useState } from 'react';

/**
 * Custom hook to detect if user is navigating with keyboard or mouse
 * @returns {boolean} isKeyboardNavigation - true if using keyboard, false if using mouse
 */
export const useKeyboardNavigation = () => {
    const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Tab' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                setIsKeyboardNavigation(true);
            }
        };

        const handleMouseDown = () => {
            setIsKeyboardNavigation(false);
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleMouseDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    return isKeyboardNavigation;
};
